'use client';

import { TSong } from '@/context/global/types/song';
import { useState, useCallback } from 'react';

export function useQueueToast() {
  const [toastSong, setToastSong] = useState<TSong | null>(null);

  const showToast = useCallback((song: TSong) => {
    setToastSong(song);

    // Auto-hide after 3 seconds
    setTimeout(() => {
      setToastSong(null);
    }, 3000);
  }, []);

  return {
    toastSong,
    showToast,
  };
}
